import { CHART_PALETTE } from '../../../utils/colors';

export const BOX_PLOT_DEFAULT = {
  legendVisibility: true,
  titlesVisibility: true,
  color: CHART_PALETTE[1],
  padding: 0.33,
  rowHeight: 24,
  valueAxsisSpace: 25,
  labelAxisMargin: 30,
  rightMargin: 12,
  minValue: 1,
  maxValue: 4,
  valueAxisStep: 0.5,
};
